import { render, staticRenderFns } from "./new-contact-dialog.vue?vue&type=template&id=24203c5a&scoped=true&"
import script from "./new-contact-dialog.vue?vue&type=script&lang=js&"
export * from "./new-contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./new-contact-dialog.vue?vue&type=style&index=0&id=24203c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24203c5a",
  null
  
)

export default component.exports